module.exports = __webpack_public_path__ + "images/liinilaevad/favicon-16x16.png";